import React from 'react';
import { Tabs as AntdTabs, TabsProps } from 'antd';

const Tabs = (props: TabsProps) => {
  return <AntdTabs {...props}></AntdTabs>;
};

export default Tabs;
